import React from "react";
import InfoTooltip from "./InfoTooltip";
import "./InfoLabel.scss";

const InfoLabel = ({ text, title, required = false }) => {
  return (
    <span className="InfoLabel">
      {text} <InfoTooltip title={title} />
      {required && <span className="required"> *</span>}
    </span>
  );
};

export default InfoLabel;
